<script>
  import Navbar from "../components/Navbar.svelte";
  import LangugePanel from "../components/LangugePanel.svelte";
  import { Route } from 'svelte-router-spa';
  import { theRoute } from "../store/shared"
  export let currentRoute;
  export let params;

  $: {
    theRoute.update(old => currentRoute);
  }

</script>
<div class="my-wrapper">
  <Navbar />
  <div class="my-content container" style="padding-left: 0 !important; padding-right: 0 !important;">
    <div class="row no-gutters">
      <div class="col-lg-2 col-md-2 col-sm-4 col-xs-4 lang_wrapper">
        <LangugePanel />
      </div>
      <div class="col-lg-10 col-md-10 col-sm-8 col-xs-8">
        <Route {currentRoute} {params} />
      </div>
    </div>
  </div>
</div>

<style>
  .my-wrapper {
    display: flex !important;
    flex-direction: column !important;
  }

  .my-content {
    height: calc(100vh - 36px) !important;
    min-height: calc(100vh - 36px) !important;
  }

  .lang_wrapper {
    height: calc(100vh - 36px) !important;
    min-height: calc(100vh - 36px) !important;
  }
</style>